const SELECTED_COMPONENT_DEBOUNCE_SECONDS = {
  PRE_DEFINED_DATE_RANGES: 1000,
  DATE_TIME_RANGE_PICKER: 1000,
};

export default SELECTED_COMPONENT_DEBOUNCE_SECONDS;
